// extracted by mini-css-extract-plugin
export var addButton = "_5d-d";
export var bullets = "_5d-e";
export var compact = "_5d-2";
export var container = "_5d-j";
export var extendedWarrantyModal = "_5d-f";
export var learn = "_5d-l";
export var learnMore = "_5d-g";
export var offeringOption = "_5d-3";
export var offeringPrice = "_5d-8";
export var offeringSubtitle = "_5d-7";
export var offeringTitle = "_5d-6";
export var offeringsContainer = "_5d-0";
export var pdpTilesBackground = "_5d-n";
export var plan = "_5d-m";
export var regular = "_5d-1";
export var remove = "_5d-k";
export var seeDetailsIcon = "_5d-i";
export var seeDetailsLink = "_5d-h";
export var selectedOption = "_5d-4";
export var shieldIcon = "_5d-b";
export var shieldIconCompact = "_5d-c";
export var subtitle = "_5d-a";
export var title = "_5d-9";
export var unselectedOption = "_5d-5";